import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/layout.vue'
import Login from '@/views/frame/shopLogin.vue'
import adminRouter from './adminRouter'
import affiliateRouter from './affiliateRouter'
import commonRouter from './commonRouter'
import devRouter from './devRouter'
import frameRouter from './frameRouter'
import goodsRouter from './goodsRouter'
import groupRouter from './groupRouter'
import housekeepingRouter from './housekeepingRouter'
import orderRouter from './orderRouter'
import partnerRouter from './partnerRouter'
import phoneRouter from './phoneRouter'
import plateformRouter from './plateformRouter'
import propertyRouter from './propertyRouter'
import shopRouter from './shopRouter'
import userRouter from './userRouter'
import couponRouter from './couponRouter'
import posRouter from './posRouter'
import config from '@/conf/config'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/views/index/index',
    children: [
      {
        path: '/views/index/index',
        name: '/views/index/index',
        component: () => import('@/views/index/index.vue')
      },
      ...adminRouter,
      ...affiliateRouter,
      ...commonRouter,
      ...devRouter,
      ...frameRouter,
      ...goodsRouter,
      ...groupRouter,
      ...housekeepingRouter,
      ...orderRouter,
      ...partnerRouter,
      ...phoneRouter,
      ...plateformRouter,
      ...propertyRouter,
      ...shopRouter,
      ...userRouter,
      ...couponRouter,
      // 其他子路由可以在这里添加
    ]
  },
  {
    path: '/pages/pos/goodsPos',
    name: '/pages/pos/goodsPos',
    component: () => import('@/views/pos/GoodsPos.vue')
  },
  {
    path: '/pages/pos/mealPos',
    name: '/pages/pos/mealPos',
    component: () => import('@/views/pos/mealPos.vue')
  },
  {
    path: '/views/frame/login',
    name: '/views/frame/login',
    component: Login,
    meta: {
      title: '登陆页面',
      icon: 'el-icon-s-home'
    }
  },
  {
    path: '/pages/frame/register',
    name: '/pages/frame/register',
    component: () => import('@/views/frame/shopRegister.vue')
  },
  {
    path: '/pages/frame/wuyeRegister',
    name: '/pages/frame/wuyeRegister',
    component: () => import('@/views/frame/wuyeRegister.vue')
  },
  {
    path: '/pages/frame/sso',
    name: '/pages/frame/sso',
    component: () => import('@/views/frame/sso.vue')
  },
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 排除静态资源路径
  if (to.path.startsWith('/img/') || to.path.startsWith('/static/') || to.path.startsWith('/js/') || to.path.startsWith('/css/')) {
    return next(); // 直接放行
  }
  if (to.path.startsWith('/formjs/') || to.path.startsWith('/bpmnjs/')
    || to.path.startsWith('/components/frame/')
    || to.path.startsWith('/bigScreen/')) {
    return next(); // 直接放行
  }
  if (to.path.endsWith('.xlsx')) {
    return next(); // 直接放行
  }
  const token = localStorage.getItem('token')
  if (to.path == '/pages/frame/register' || to.path == '/pages/frame/wuyeRegister' || to.path == '/pages/frame/sso' || to.path == '/pages/pos/goodsPos' || to.path == '/pages/pos/mealPos') {
    if ((to.path == '/pages/pos/goodsPos' || to.path == '/pages/pos/mealPos') && !token) {
      next('/views/frame/login')
      return
    }
    return next()
  }
  if (to.path !== '/views/frame/login' && !token) {
    next('/views/frame/login')
  } else {
    let _title = to.meta.title;
    if (!_title) {
      _title = config.systemName
    } else {
      _title = _title + ' - ' + config.systemName
    }
    document.title = _title
    next()
  }
})

export default router
